export enum AppTypes {
  Dashboard = 'Dashboard',
  OnboardingRequest = 'Onboarding Request',
  ClientOutreachPortal = 'Client Outreach Portal',
  DocLibrary = 'Docu Library',
}
